import { Component, OnInit,  OnDestroy} from '@angular/core';
import { UntypedFormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../_services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { catchError, first, map, tap } from 'rxjs/operators';
import { AnalyticsService } from 'src/app/_services/analytics.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { Subscription, timer, of, interval } from 'rxjs';
import { clickGAEvent } from 'src/app/_helpers/ga-events';
import { pageLoadEvent } from 'src/app/_helpers/ga-events';
import { addGAEventListener, removeGAEventListener } from 'src/app/_helpers/ga-events';
import * as Sentry from "@sentry/angular-ivy";
declare var zcAction : any;
@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {
  countSubscription: any = Subscription;
  validateForm! : UntypedFormGroup;
  passwordVisible: boolean = false;
  submitted: boolean = false;
  passwordStrength: any;
  passwordStrengthAlternate: number[] = [];
  state: number = 1;
  loading: boolean = false;
  window: any;
  errorMsg: string = '';
  errorValue = "success";
  infobox = false;
  otp : any;
  otpMobile = true;
  tempToken: any;
  resendShow = false;
  resendOtpRequest = false;
  passwordStrengthValues: any = {
    hasDigit : false,
    hasSpecialChar : false,
    hasUpperCase : false,
    hasLowerCase : false,
    minLength : false,
  }
  timeLeft = 30;
  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    private authService: AuthService,
    private notification: NzNotificationService,
    private analyticsService: AnalyticsService
  ) { }

  ngOnInit(): void {
    pageLoadEvent("signup_page");
    addGAEventListener();
    this.validateForm = this.fb.group({
      firstname: [null, [Validators.required]],
      lastname: [null, [Validators.required]],
      email: [null, [Validators.email, Validators.required]],
      phonenumber: [null, [Validators.required]],
      password: [null, [Validators.required, Validators.minLength(9)]],
      phoneNumberPrefix: [null, [Validators.required]],
    });
    this.getAllCountry();
  }

  ngAfterViewInit(): void {
    removeGAEventListener();
    addGAEventListener();
  }

  ngOnDestroy() {
      removeGAEventListener();
      this.countSubscription.unsubscribe();
  }

  getAllCountry(){
    this.validateForm.patchValue({
      phonenumber : '+234 ',
      phoneNumberPrefix: 'Nigeria (+234)'
    })
  }

  // getTheCountry(){
  //   let payload = {};
  //   this.authService.getTheCountryData(payload).pipe(first()).subscribe({
  //     next: (res : any ) => {
  //       zcAction('selfsignup_form');
  //       if (!res.error) {
  //         if(res ?.country_name == 'Kenya'){
  //           this.validateForm.patchValue({
  //             phonenumber : '+254',
  //             phoneNumberPrefix: 'Kenya (+254)'
  //           })
  //         }
  //         if(res ?.country_name == 'Nigeria'){
  //           this.validateForm.patchValue({
  //             phonenumber : '+234',
  //             phoneNumberPrefix: 'Nigeria (+234)'
  //           })
  //         } else {
  //           this.validateForm.patchValue({
  //             phonenumber : '+234',
  //             phoneNumberPrefix: 'Nigeria (+234)'
  //           })
  //         }
  //       }else{
  //         this.validateForm.patchValue({
  //           phonenumber : '+234',
  //           phoneNumberPrefix: 'Nigeria (+234)'
  //         })
  //       }
  //     },
  //     error: (res) => {
  //     }
  //   });
  // }

  countryChange(e : any){
    if(e == 'Nigeria (+234)'){
      clickGAEvent("select_country","signup-country-phone-code_click","signup_page",e);
      this.validateForm.patchValue({
        phonenumber : '+234 ',
      })
    }
    if(e == 'Kenya (+254)'){
      clickGAEvent("select_country","signup-country-phone-code_click","signup_page", e);
      this.validateForm.patchValue({
        phonenumber : '+254 ',
      })
    }
  }

  get f() { return this.validateForm.controls; }
  
  submitForm() {
    if (this.validateForm.valid) {
      if(this.passwordStrength ?.length < 4 || !this.f.firstname.value || !this.f.lastname.value || !this.f.phonenumber.value || !this.f.email.value) return;
      this.loading = true;
      let phoneNumberChange = this.f.phonenumber.value.replace(/\s/g, "").split('+')[1];
      // let phoneNumberChange = Number(String(this.f.phonenumber.value).charAt(0)) == 0 ? '234' + this.f.phonenumber.value.slice(1, this.f.phonenumber.value.length) : this.f.phonenumber.value;
      const payload = {
        contact_email : this.f.email.value,
        contact_firstname : this.f.firstname.value,
        contact_lastname : this.f.lastname.value,
        contact_number : phoneNumberChange,
        password: this.f.password.value,
        verification_channel : this.otpMobile ? 'SMS' : 'EMAIL',
      }
      
      this.authService.selfSignup(payload).pipe(first()).subscribe({
        next: (res : any ) => {
          this.loading = false;
          this.infobox = true;
          this.errorValue = res.error ? 'error' : 'success' ;
          zcAction('selfsignup_form');
          if (!res.error) {
            this.tempToken = res.response.verificationToken;
            this.analyticsService.loginEvent(true);
            this.createNotification('success','OTP Sent', 'A one-time password has been sent to your registered phone number.');
            this.state = 2;
            this.infobox = false;
          }else{
            Sentry.captureMessage('Error: ' + res.error);
            this.errorMsg = res.response.message;
            this.analyticsService.loginEvent(false);
            this.createNotification('error','Error', res.response.message);
          }
        },
        error: (res) => {
          Sentry.captureMessage('Error: ' + res);
          this.loading = false;
          this.createNotification('error','Error', res.response);
        }
      });

    } else {
      Object.values(this.validateForm.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  countdown() {
      if (this.timeLeft == 0) {
          this.resendShow = !this.resendShow;
          this.countSubscription.unsubscribe();
      } else {
          this.timeLeft--;
      }
  }

  goTo(url : any){
    clickGAEvent("route_click","signup-login_click", "signup_page")
    this.router.navigate([url]);
 }

  reSendOtp(){
    clickGAEvent("button_click","signup-resend-otp_click","signup_page");
    this.timeLeft = 30; 
    if(!this.f.email.value) return;
    if(!this.f.phonenumber.value) return;
    let phoneNumberChange = this.f.phonenumber.value.replace(/\s/g, "").split('+')[1];
    // let phoneNumberChange = Number(String(this.f.phonenumber.value).charAt(0)) == 0 ? '234' + this.f.phonenumber.value.slice(1, this.f.phonenumber.value.length) : this.f.phonenumber.value;
    const payload = {
      phoneNumber : phoneNumberChange ,
      channel : this.otpMobile ? 'SMS' : 'EMAIL',
      email : this.f.email.value,
    }
    this.resendShow = !this.resendShow;
    this.countSubscription = interval(1000).subscribe(x => { this.countdown() },
      (error: any) => {
        Sentry.captureMessage('Error: ' + error);
      });
    this.resendOtpRequest = true;
    this.authService
    .resendOtp(payload)
    .pipe(first())
    .subscribe({
      next: (res : any ) => {
        this.errorValue = res.error ? 'error' : 'success' ;
        if (!res.error) {
          this.tempToken = res.response.verificationToken;
          this.createNotification('success', 'OTP Sent', this.otpMobile ? 'A one-time password has been sent to your registered phone number.' : 'A one-time password has been sent to your registered email ID.')
        }else{
          Sentry.captureMessage('Error: ' + res.error);
          this.errorMsg = res.response;
          this.createNotification('error','OTP not sent', 'Failed to resend the OTP. Please try again.');
        }
      },
      error: (error : any) => {
        Sentry.captureMessage('Error: ' + error);
        this.loading = false;
        this.createNotification('error','OTP not sent', 'Failed to resend the OTP. Please try again.');
      }
    });
  }


  resendActivationMail() {
    clickGAEvent("button_click","signup-resend-email_click","signup_page");
    if(!this.f.email.value) return;
    this.loading = true;
    const payload = {
      email : this.f.email.value
    }
    
    this.authService
    .resendActivationMail(payload)
    .pipe(first())
    .subscribe({
      next: (res : any ) => {
        this.loading = false;
        this.errorValue = res.error ? 'error' : 'success' ;
        if (!res.error) {
          // this.createNotification('success','Email Sent', 'The verification email has been resent to your email')
        }else{
          Sentry.captureMessage('Error: ' + res.error);
          this.errorMsg = res.response;
          // this.createNotification('error','Email not Sent', 'Error resending email');
        }
      },
      error: (error : any) => {
        Sentry.captureMessage('Error: ' + error);
        this.loading = false;
        this.createNotification('error','Email not Sent', 'Error resending email');
      }
    });
  }

  verifyOtp() {
    clickGAEvent("button_click","signup-verify-otp_click","signup_page")
    this.loading = true;
    let phoneNumberChange = this.f.phonenumber.value.replace(/\s/g, "").split('+')[1];
    // let phoneNumberChange = Number(String(this.f.phonenumber.value).charAt(0)) == 0 ? '234' + this.f.phonenumber.value.slice(1, this.f.phonenumber.value.length) : this.f.phonenumber.value;
    const payload = {
      channel : this.otpMobile ? 'sms' : 'email',
      channelReferenceId : this.otpMobile  ? phoneNumberChange : this.f.email.value,
      verificationToken : this.tempToken,
      otp : this.otp,
    }
    let country = this.f.phoneNumberPrefix.value == 'Kenya (+254)' ? 'Kenya' : 'Nigeria';
    this.authService.changeCountry(country);
    this.authService.verifyOtp(payload).pipe(first()).subscribe({
      next: (res : any ) => {
        this.loading = false;
        if (!res.error) {
          // this.router.navigateByUrl(`/auth/newbusiness`);
          // this.router.navigateByUrl(`/auth/newbusiness?token=${res.response.token}`);
          this.router.navigate([`/auth/newbusiness`, { token : res.response.token, email: this.f.email.value, password: this.f.password.value}]);
          // this.createNotification('success','Email Sent', 'The verification email has been resent to your email')
        }else{
          Sentry.captureMessage('Error: ' + res.error);
          if(res ?.response ?.responseCode == "OTP_ERROR_400_06"){
            this.createNotification('error', res ?.response ?.message, res ?.response ?.message);
          }
          if(res ?.response ?.responseCode == "OTP_ERROR_400_07"){
            this.createNotification('error',res ?.response ?.message, res ?.response ?.message);
          }
          if(res ?.response ?.responseCode == "OTP_ERROR_400_08"){
            this.createNotification('error',res ?.response ?.message, 'The OTP you have entered is incorrect. Please try again.');
          }
          if(res ?.response ?.responseCode == "OTP_ERROR_400_09"){
            this.createNotification('error',res ?.response ?.message, 'Click on “Resend OTP” to receive a new verification code');
          }
          if(res ?.response ?.responseCode == "OTP_ERROR_400_10"){
            this.createNotification('error',res ?.response ?.message, res ?.response ?.message);
          }
          if(res ?.response ?.responseCode == "OTP_ERROR_400_11"){
            this.createNotification('error',res ?.response ?.message, res ?.response ?.message);
          }
        }
      },
      error: (err : any) => {
        Sentry.captureMessage('Error: ' + err);
        this.loading = false;
        if(err ?.response ?.responseCode == "OTP_ERROR_400_06"){
          this.createNotification('error', err ?.response ?.message, err ?.response ?.message);
        }
        if(err ?.response ?.responseCode == "OTP_ERROR_400_07"){
          this.createNotification('error',err ?.response ?.message, err ?.response ?.message);
        }
        if(err ?.response ?.responseCode == "OTP_ERROR_400_08"){
          this.createNotification('error',err ?.response ?.message, 'The OTP you have entered is incorrect. Please try again.');
        }
        if(err ?.response ?.responseCode == "OTP_ERROR_400_09"){
          this.createNotification('error',err ?.response ?.message, 'Click on “Resend OTP” to receive a new verification code');
        }
        if(err ?.response ?.responseCode == "OTP_ERROR_400_10"){
          this.createNotification('error',err ?.response ?.message, err ?.response ?.message);
        }
        if(err ?.response ?.responseCode == "OTP_ERROR_400_11"){
          this.createNotification('error',err ?.response ?.message, err ?.response ?.message);
        }
        // this.createNotification('error','OTP not Sent', 'Failed to resend the OTP. Please try again.');
      }
    });
  }


  togglePasswordVisibility(){
    clickGAEvent("show_password","signup-password-visibility_click","signup_page");
    this.passwordVisible = !this.passwordVisible;
  }

  onPasswordChange($event: any){
    this.passwordStrengthValues = {
      hasDigit : false,
      hasSpecialChar : false,
      hasUpperCase : false,
      hasLowerCase : false,
      minLength : false,
    }
    this.passwordStrength = this.getPasswordStrength();
  }

  getPasswordStrength(){
    const password = this.f.password.value;
    const minLength = password?.length > 8;
    const hasDigit = /\d/.test(password);
    const hasSpecialChar = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(password)
    const hasUpperCase = password ?.toLowerCase() !== password;
    const hasLowerCase = password ?.toUpperCase() !== password;
    let strength = [];
    let alternate = [];

    if (hasDigit) {
      this.passwordStrengthValues.hasDigit = true;
      strength.push(1)
    }
    if (hasSpecialChar) {
      this.passwordStrengthValues.hasSpecialChar = true;
      strength.push(1);
    }
    if (hasUpperCase) {
      this.passwordStrengthValues.hasUpperCase = true;
      strength.push(1);
    }
    if (hasLowerCase) {
      this.passwordStrengthValues.hasLowerCase = true;
      strength.push(1);
    }
    if (minLength) {
      this.passwordStrengthValues.minLength = true;
      strength.push(1);
    }

    for (let i = 0; i < 5 - strength.length; i++) {
      alternate.push(1);
    }
    this.passwordStrengthAlternate = alternate;
    return strength;
  }


  switchState($event: any){
    clickGAEvent("button_click","signup-change-email_click","signup_page")
    $event.preventDefault();
    this.state = 1;
  }

  switchValue(){
    this.otpMobile = !this.otpMobile;
    this.resendShow = false;
    this.submitData();
    if(this.resendOtpRequest){
      this.countSubscription.unsubscribe();
    }
  }

  submitData(){
    let phoneNumberChange = this.f.phonenumber.value.replace(/\s/g, "").split('+')[1];
    // let phoneNumberChange = Number(String(this.f.phonenumber.value).charAt(0)) == 0 ? '234' + this.f.phonenumber.value.slice(1, this.f.phonenumber.value.length) : this.f.phonenumber.value;
    const payload = {
      contact_email : this.f.email.value,
      contact_firstname : this.f.firstname.value,
      contact_lastname : this.f.lastname.value,
      contact_number : phoneNumberChange,
      password: this.f.password.value,
      verification_channel : this.otpMobile ? 'SMS' : 'EMAIL',
    }
    this.authService.selfSignup(payload).pipe(first()).subscribe({
      next: (res : any ) => {
        this.loading = false;
        if (!res.error) {
          this.tempToken = res.response.verificationToken;
          let message = this.otpMobile ? 'A one-time password has been sent to your registered phone number.' : 'A one-time password has been sent to your registered email ID.';
          this.createNotification('success','OTP Sent', message);
        }else{
          Sentry.captureMessage('Error: ' + res.error);
          this.createNotification('error','Error', res.response);
        }
      },
      error: (error : any) => {
        Sentry.captureMessage('Error: ' + error);
        this.loading = false;
        this.createNotification('error','OTP expired!','Click on “Resend OTP” to receive a new verification code');
      }
    });
  }

  createNotification(type: string, title: string, body: string): void {
    this.notification.create(
      type,
      title,
      body
    );
  }

  triggerGAInput(inputText: string):void{
    clickGAEvent("input_text", "signup-" + inputText , "signup_page")
  }

  triggerGATerms(event: Event):void {
    event.preventDefault();
    clickGAEvent("route_click","signup-terms-&-conditions_click","signup_page");
    const href= "https://prime.terragongroup.com/terms.html";
    window.open(href, '_blank');
  }

  triggerGAButton(buttonName: string):void{
    clickGAEvent("button_click","signup-"+ buttonName + "_click","signup_page")
  }

}
